/* Native Shopify integration. Prices and availability originate in Liquid and are enforced again by Shopify. */
(function (root) {
  'use strict';
  const Core = {
    choose(offers, requested) {
      const target = offers.find(o => o.units === Number(requested));
      return target || offers[0];
    },
    payload(offer) {
      if (!offer || !offer.available || !Number.isSafeInteger(offer.variantId) || offer.variantId <= 0 || !Number.isInteger(offer.quantity) || offer.quantity < 1) throw new Error('Unavailable selection');
      return {id: offer.variantId, quantity: offer.quantity};
    },
    best(offers, offer) {
      return offer.units > 1 && offer.available && offer.retail > offer.price && offers.filter(o => o.available && o.units !== offer.units).every(o => o.price * offer.units > offer.price * o.units);
    },
    error(data, fallback) {
      return typeof data?.description === 'string' ? data.description : typeof data?.message === 'string' ? data.message : fallback;
    },
    orderCatalog(items, sort, hero, packages = false) {
      return [...items].sort((a,b) => {
        const stock = Number(b.available) - Number(a.available);
        if (stock) return stock;
        const pin = a.available ? Number(b.handle === hero) - Number(a.handle === hero) : 0;
        if (pin) return pin;
        if (sort === 'price-ascending' && a.price !== b.price) return a.price-b.price;
        if (sort === 'price-descending' && a.price !== b.price) return b.price-a.price;
        return packages ? 0 : b.created-a.created;
      });
    }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = Core;
  if (!root.document) return;
  const doc = root.document;
  doc.documentElement.classList.add('js');
  const configNode = doc.getElementById('DogConfig');
  if (!configNode) return;
  const cfg = JSON.parse(configNode.textContent);
  const $ = (s, within = doc) => within.querySelector(s);
  const $$ = (s, within = doc) => Array.from(within.querySelectorAll(s));
  const esc = s => String(s ?? '').replace(/[&<>"']/g, x => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[x]));
  const plain = s => { const el = doc.createElement('span'); el.innerHTML = String(s ?? ''); return el.textContent; };
  const ar = cfg.locale === 'ar';
  const t = (en, arabic) => ar ? arabic : en;
  const optionsByForm = new WeakMap();
  let cartBusy = false, dialog = null, lastFocus = null;
  const focusable = el => $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]',el).filter(x => x.getClientRects().length && !x.closest('[hidden]'));
  let previousOverflow='', outside=[];
  function closeDialog(restore=true) {
    if(!dialog)return;
    const old=dialog; dialog=null;
    $$('video',old).forEach(v=>v.pause());
    const overlay=old.parentElement;overlay.hidden=true;overlay.replaceChildren();
    for(const [el,was] of outside)el.inert=was;outside=[];
    doc.body.style.overflow=previousOverflow;
    const target=lastFocus;lastFocus=null;
    if(restore&&target?.isConnected)target.focus?.({preventScroll:true});
  }
  function showDialog(content,kind,label){
    if(dialog)closeDialog(false);
    lastFocus=doc.activeElement;previousOverflow=doc.body.style.overflow;
    const overlay=$(kind==='drawer'?'#drawerOverlay':'#modalOverlay');
    dialog=doc.createElement('section');dialog.className=kind==='drawer'?'drawer dog-cart-drawer':'modal dog-modal';
    dialog.setAttribute('role','dialog');dialog.setAttribute('aria-modal','true');dialog.setAttribute('aria-label',label);dialog.tabIndex=-1;
    if(typeof content==='string')dialog.innerHTML=content;else dialog.append(content);
    overlay.replaceChildren(dialog);overlay.hidden=false;
    outside=[...doc.body.children].filter(e=>e!==overlay&&(['MAIN','HEADER','FOOTER'].includes(e.tagName)||e.classList.contains('shopify-section-group-header-group')||e.classList.contains('shopify-section-group-footer-group'))).map(e=>[e,Boolean(e.inert)]);
    outside.forEach(([e])=>{e.inert=true;});
    doc.body.style.overflow='hidden';(focusable(dialog)[0]||dialog).focus({preventScroll:true});return dialog;
  }
  root.addEventListener('pagehide',()=>closeDialog(false));
  async function request(url, init = {}) {
    const response = await fetch(url, {credentials:'same-origin', headers:{Accept:'application/json',...(init.headers || {})}, ...init});
    let data;
    try { data = await response.json(); } catch (_) { throw new Error(cfg.strings.error); }
    if (!response.ok || data.status >= 400) throw new Error(Core.error(data, cfg.strings.error));
    return data;
  }
  async function section(name,path=cfg.root) {
    const url = new URL(path, location.origin);
    const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
    url.searchParams.set('section_id', name);
    const response = await fetch(url, {credentials:'same-origin', headers:{Accept:'text/html'}});
    if (!response.ok) throw new Error(cfg.strings.error);
    return response.text();
  }
  function cartCount(html) {
    const template = doc.createElement('template'); template.innerHTML = html;
    const node = $('[data-cart-count]',template.content);
    if (node) $$('[data-cart-count]').filter(n => !n.classList.contains('cart-drawer-content')).forEach(n => { n.textContent = node.dataset.cartCount; n.hidden = Number(node.dataset.cartCount) === 0; });
  }
  async function openCart(html) {
    const content = html || await section('cart-drawer');
    const check=doc.createElement('template');check.innerHTML=content;
    if(!check.content.querySelector('.cart-drawer-content'))throw new Error(cfg.strings.error);
    cartCount(content);
    showDialog(content,'drawer',t('Your bag','سلة التسوق'));
  }
  function setBusy(value) {
    cartBusy = value;
    $$('[data-dog-add] button[type="submit"], [data-sticky-add], [data-cart-quantity], [data-upgrade-confirm], [data-dog-complement], [name="checkout"]').forEach(el => {
      if (value) { el.dataset.wasDisabled = String(el.disabled); el.disabled = true; }
      else if (el.dataset.wasDisabled !== undefined) { el.disabled = el.dataset.wasDisabled === 'true'; delete el.dataset.wasDisabled; }
    });
    $$('[data-dog-add], [data-cart-page], .dog-cart-drawer').forEach(el => el.setAttribute('aria-busy',String(value)));
  }
  function errorWithin(container, message) {
    const el = $('[data-cart-error]',container) || $('.form-error',container) || $('[data-cart-error]');
    if (el) { el.textContent = message; el.hidden = false; el.tabIndex = -1; el.focus(); }
    else { const toast = $('#toast'); toast.textContent = message; toast.classList.add('visible'); setTimeout(() => toast.classList.remove('visible'),6000); }
  }
  async function refreshCart(data) {
    const content = data.sections?.['cart-drawer'] || await section('cart-drawer');
    cartCount(content);
    if (dialog?.classList.contains('dog-cart-drawer')) {
      const focused = doc.activeElement;
      const key = focused?.dataset?.key;
      dialog.innerHTML = content;
      const match = key ? $$('[data-key]',dialog).find(n => n.dataset.key === key) : null;
      (match || $('[data-close-dialog]',dialog) || dialog).focus();
    }
    const cartPage = $('[data-cart-page]');
    if (cartPage) {
      const html = await section(cartPage.dataset.sectionId||'main-cart',cfg.cartUrl);
      const temp = doc.createElement('template'); temp.innerHTML = html;
      const replacement = $('[data-cart-page]',temp.content);
      if (replacement) cartPage.replaceWith(replacement);
    }
    return content;
  }
  async function changeLine(key, quantity, control) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    setBusy(true);
    try {
      const data = await request(cfg.cartChangeUrl, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity,sections:['cart-drawer'],sections_url:location.pathname})});
      await refreshCart(data);
    } catch (e) { errorWithin(control.closest('form') || doc,e.message); }
    finally { setBusy(false); }
  }
  const cartSnapshot=()=>request(cfg.cartJsonUrl||cfg.cartUrl+'.js',{cache:'no-store'});
  const postJSON=(url,body)=>request(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...body,sections:['cart-drawer'],sections_url:location.pathname})});
  const newToken=()=>root.crypto?.randomUUID?.() || (Date.now().toString(36)+'-'+Math.random().toString(36).slice(2));
  function sameProperties(a,b){
    const x=a||{},y=b||{},keys=Object.keys(x);return keys.length===Object.keys(y).length&&keys.every(k=>String(x[k])===String(y[k]));
  }
  function findSource(cart,source){
    const items=(cart.items||[]).filter(l=>Number(l.variant_id)===Number(source.variant_id)&&sameProperties(l.properties,source.properties));
    return items.find(l=>l.key===source.key)||(items.length===1?items[0]:null);
  }
  function showCartMessage(msg){
    const box=dialog?.querySelector('[data-cart-error]')||doc.querySelector('[data-cart-page] [data-cart-error]');
    if(box){box.hidden=false;box.textContent=msg;box.setAttribute('role','alert');box.tabIndex=-1;box.focus({preventScroll:true});}
    else errorWithin(doc,msg);
  }
  async function alignCartView(){
    try{await refreshCart({});}catch(_){location.assign(cfg.cartUrl);}
  }
  async function upgrade(btn){
    if(cartBusy)return;
    const changed=t('Your bag changed. Review your items before trying again.','تغيّرت محتويات السلة. راجع الاختيارات قبل المحاولة مجدداً.');
    const token=newToken();let source=null,attempted=false;
    setBusy(true);
    try{
      const before=await cartSnapshot();source=before.items.find(l=>l.key===btn.dataset.key);
      const n=Number(btn.dataset.units),v=Number(btn.dataset.target),base=Number(btn.dataset.source);
      if(!source||source.quantity!==1||Number(source.variant_id)!==Number(btn.dataset.old)||source.properties?._dog_offer_rule!=='fixed-set-v5'||
         source.properties._dog_source_handle!==btn.dataset.handle||Number(source.properties._dog_source_variant)!==base||Number(source.properties._dog_set_units)!==Number(btn.dataset.from)||
         ![2,3].includes(n)||n<=Number(btn.dataset.from)||!Number.isSafeInteger(v)||v<=0||v===Number(source.variant_id)||source.selling_plan_allocation)throw new Error(changed);
      attempted=true;
      await postJSON(cfg.cartAddUrl,{items:[{id:v,quantity:1,properties:{_dog_offer_rule:'fixed-set-v5',_dog_set_units:String(n),_dog_source_handle:btn.dataset.handle,_dog_source_variant:String(base),_dog_upgrade_token:token}}]});
      const mid=await cartSnapshot(),target=mid.items.find(l=>l.properties?._dog_upgrade_token===token&&Number(l.variant_id)===v&&l.quantity===1),old=findSource(mid,source);
      if(!target||!old||old.quantity!==1)throw new Error(changed);
      await postJSON(cfg.cartChangeUrl,{id:old.key,quantity:0});
      const end=await cartSnapshot();
      if(findSource(end,source)||!end.items.some(l=>l.properties?._dog_upgrade_token===token&&Number(l.variant_id)===v&&l.quantity===1))throw new Error(changed);
      await refreshCart({});
    }catch(err){
      let msg=err.message||changed;
      if(attempted&&source){
        try{
          const live=await cartSnapshot(),old=findSource(live,source),target=live.items.find(l=>l.properties?._dog_upgrade_token===token);
          if(old&&target&&target.quantity===1){await postJSON(cfg.cartChangeUrl,{id:target.key,quantity:0});msg=t('The upgrade wasn’t completed. Your original selection is still in the bag.','لم تكتمل الترقية. لا يزال اختيارك الأصلي في السلة.');}
          else if(!old&&target&&target.quantity===1){await alignCartView();return;}
          else if(old&&!target){msg=err.message||changed;}
          else{msg=changed;}
        }catch(_){msg=changed;}
      }
      await alignCartView();showCartMessage(msg);
    }finally{setBusy(false);}
  }
  async function quickAdd(b){
    if(cartBusy)return;
    const id=Number(b.dataset.dogComplement);if(!Number.isSafeInteger(id)||id<=0)return;
    const item={id,quantity:1};
    if(b.dataset.kind==='single')item.properties={_dog_offer_rule:'fixed-set-v5',_dog_set_units:'1',_dog_source_handle:b.dataset.handle,_dog_source_variant:String(id)};
    setBusy(true);let success=false;
    try{const result=await postJSON(cfg.cartAddUrl,{items:[item]});success=true;await refreshCart(result);}
    catch(err){if(success)location.assign(cfg.cartUrl);else{await alignCartView();showCartMessage(err.message||cfg.strings.error);}}
    finally{setBusy(false);}
  }
  doc.addEventListener('click',e=>{
    const b=e.target.closest('[data-upgrade-confirm],[data-dog-complement],[data-keep-set]');if(!b)return;e.preventDefault();
    if(b.matches('[data-keep-set]')){const d=b.closest('details');d.open=false;d.querySelector('summary')?.focus();return;}
    if(b.matches('[data-upgrade-confirm]'))upgrade(b);else quickAdd(b);
  });

  function selectOffer(form, offer, updateURL = false) {
    const offers = optionsByForm.get(form);
    if (!offer || !offers) return;
    form.elements.id.value = offer.variantId || '';
    form.elements.quantity.value = offer.quantity;
    form.dataset.selectedUnits = offer.units;
    $$('[data-offer-units]', form).forEach(b => { const selected = Number(b.dataset.offerUnits) === offer.units; b.classList.toggle('selected',selected); b.setAttribute('aria-pressed',String(selected)); });
    const soldOut = t('Sold out','نفدت الكمية');
    const label = offer.available ? cfg.strings.add + ' · ' + plain(offer.priceText) : soldOut;
    $('[data-add-label]', form).textContent = label;
    $('[data-add-button]', form).disabled = !offer.available;
    $('[data-add-button]', form).classList.toggle('sold-out-button',!offer.available);
    const photoBadge = $('[data-product-sold-out]');
    if (photoBadge) photoBadge.hidden = offer.available;
    const addIcon = $('[data-add-icon]', form);
    if (addIcon) addIcon.hidden = !offer.available;
    $('[data-selection-summary]', form).innerHTML = '<span>'+esc(offer.label)+' '+esc(cfg.strings.selected)+'</span><strong>'+esc(offer.retail > offer.price ? cfg.strings.saved+' '+plain(offer.savingText) : cfg.strings.single)+'</strong>';
    const marker=$('[data-campaign-marker]',form);
    if(marker){marker.hidden=!offer.campaign;marker.innerHTML=offer.campaign?'<span class="bf-campaign-label">'+t('Black Friday','الجمعة السوداء')+' <span class="savings-badge bf-badge">'+t('50% OFF','خصم ٥٠٪')+'</span></span>':'';}
    const sticky = $('[data-sticky-summary]');
    if (sticky) sticky.textContent = offer.label+' · '+plain(offer.priceText);
    const button = $('[data-sticky-add]');
    if (button) { button.disabled = !offer.available; button.classList.toggle('sold-out-button',!offer.available); button.textContent = offer.available ? cfg.strings.add : soldOut; }
    if (updateURL) { const url = new URL(location.href); url.searchParams.set('pack',offer.units); history.replaceState(null,'',url); }
  }
  function initOffers() {
    $$('[data-offer-data]').forEach(el => {
      const form = el.closest('form'), offers = JSON.parse(el.textContent);
      optionsByForm.set(form,offers);
      $('[data-quantity-options]',form).style.gridTemplateColumns = 'repeat('+offers.length+', minmax(0, 1fr))';
      $('[data-quantity-options]',form).innerHTML = offers.map(o => {
        const saving = o.retail > o.price, best = Core.best(offers,o);
        return '<button type="button" class="quantity-option" data-offer-units="'+o.units+'" aria-pressed="false">'+(best?'<span class="best-tag">'+t('BEST VALUE','أفضل قيمة')+'</span>':'')+'<span class="offer-label"><span class="radio-dot" aria-hidden="true"></span><strong>'+esc(o.label)+'</strong></span><strong class="offer-price '+(saving?'bf-current':'')+'"><bdi>'+esc(plain(o.priceText))+'</bdi></strong><span class="offer-retail">'+(saving?'<s class="bf-reference"><bdi>'+esc(plain(o.retailText))+'</bdi></s>':esc(t('Regular price','السعر المعتاد')))+'</span><span class="offer-unit">'+esc(plain(o.unitText))+'<small>'+t('per item','للعبوة')+'</small></span>'+(o.available ? (o.campaign?'':saving?'<span class="savings-badge">'+t('Save ','توفير ')+esc(plain(o.savingText))+'</span>':'<span class="single-price-note">'+esc(o.units===1 ? t('Start with one','البداية بعبوة') : t('Your quantity','الكمية المختارة'))+'</span>'):'<span class="single-price-note">'+esc(cfg.strings.unavailable)+'</span>')+'</button>';
      }).join('');
      const requested = new URL(location.href).searchParams.get('pack') || 1;
      selectOffer(form,Core.choose(offers,requested));
    });
  }
  doc.addEventListener('submit',async event => {
    if(cartBusy&&(event.submitter?.name==='checkout'||event.target.querySelector?.('[name="checkout"]'))){event.preventDefault();return;}
    const form = event.target.closest('[data-dog-add]');
    if (!form || !root.fetch) return;
    event.preventDefault();
    if (cartBusy) return;
    const offers = optionsByForm.get(form);
    if (offers) {
      try { Core.payload(Core.choose(offers,form.dataset.selectedUnits)); }
      catch (_) { errorWithin(form,cfg.strings.unavailable); return; }
    }
    const data = new FormData(form);
    if (offers) {
      const selected = Core.choose(offers,form.dataset.selectedUnits);
      const payload = Core.payload(selected);
      data.set('id',String(payload.id)); data.set('quantity',String(payload.quantity));
      // Separate real bundle variants keep their own fixed prices. These private
      // properties identify the selection for display and legacy-cart recovery;
      // they do not set a price or create a Shopify inventory relationship.
      data.set('properties[_dog_offer_rule]','fixed-set-v5');
      data.set('properties[_dog_set_units]',String(selected.units));
      data.set('properties[_dog_source_handle]',selected.sourceHandle);
      data.set('properties[_dog_source_variant]',String(selected.sourceVariantId));
    }
    data.set('sections','cart-drawer'); data.set('sections_url',location.pathname);
    const error = $('.form-error',form); if (error) error.hidden = true;
    setBusy(true);
    let added = false;
    try {
      const result = await request(cfg.cartAddUrl,{method:'POST',body:data});
      added = true;
      const content = await refreshCart(result);
      await openCart(content);
    } catch (e) {
      if (added) location.assign(cfg.cartUrl);
      else errorWithin(form,e.message);
    } finally { setBusy(false); }
  });
  doc.addEventListener('click',async event => {
    const target = event.target.closest('button,a,[data-close-dialog]');
    if (event.target.classList?.contains('overlay')) { closeDialog(); return; }
    if (!target) return;
    if (target.matches('[data-close-dialog]')) { event.preventDefault(); closeDialog(); }
    if (target.matches('[data-open-cart]')) { event.preventDefault(); try { await openCart(); } catch (_) { location.assign(cfg.cartUrl); } }
    if (target.matches('[data-cart-remove]')) { event.preventDefault(); await changeLine(target.dataset.key,0,target); }
    if (target.matches('[data-offer-units]')) {
      if (cartBusy) return;
      const form=target.closest('form'); selectOffer(form,Core.choose(optionsByForm.get(form),target.dataset.offerUnits),true);
    }
    if (target.matches('[data-gallery-src]')) {
      const image = $('#mainProductPhoto'); image.src = target.dataset.gallerySrc; image.removeAttribute('srcset'); image.alt = target.dataset.galleryAlt;
      $$('[data-gallery-src]').forEach(b => b.classList.toggle('active',b===target));
    }
    if (target.matches('[data-enlarge]')) {
      const fragment = doc.createElement('div');
      const close = doc.createElement('button'); close.type='button';close.className='icon-button modal-close';close.dataset.closeDialog='';close.setAttribute('aria-label',cfg.strings.close);close.textContent='×';
      const image = $('#mainProductPhoto').cloneNode(); image.removeAttribute('id');image.removeAttribute('sizes');image.removeAttribute('srcset');
      fragment.append(close,image); showDialog(fragment,'modal',image.alt);
    }
    if (target.matches('[data-video]')) {
      event.preventDefault();
      const fragment=doc.createElement('div'), close=doc.createElement('button'), heading=doc.createElement('h2'), video=doc.createElement('video');
      close.className='icon-button modal-close';close.dataset.closeDialog='';close.setAttribute('aria-label',cfg.strings.close);close.textContent='×';
      heading.textContent=target.dataset.videoTitle;
      video.controls=true;video.playsInline=true;video.preload='none';video.src=target.dataset.video;
      const poster=target.querySelector('img');if(poster)video.poster=poster.src;
      fragment.append(close,heading,video);showDialog(fragment,'modal',heading.textContent);video.play().catch(()=>{});
    }
    if (target.matches('[data-filter-kind]')) {
      const active=target.classList.toggle('active');target.setAttribute('aria-pressed',String(active));
      const cards=$$('.dog-catalog-grid [data-kind]');cards.forEach(c=>c.hidden=active&&c.dataset.kind!==target.dataset.filterKind);
      const empty=$('[data-filter-empty]');if(empty)empty.hidden=cards.some(c=>!c.hidden);
    }
  });
  doc.addEventListener('change',event=>{
    const el=event.target;
    if(el.matches('[data-cart-quantity]')) {if(el.checkValidity())changeLine(el.dataset.key,Number(el.value),el);else el.reportValidity();}
    if(el.matches('[data-variant-select]')) {const url=new URL(location.href);url.searchParams.set('variant',el.value);url.searchParams.delete('pack');location.assign(url);}
    if(el.matches('[data-sort]')) el.form.requestSubmit();
    if(el.matches('[data-country-select]')) populateProvince(el);
  });
  function populateProvince(select) {
    const province=doc.getElementById(select.dataset.province);if(!province)return;
    const options=JSON.parse(select.selectedOptions[0]?.dataset.provinces||'[]');
    province.replaceChildren(...options.map(([value,label])=>new Option(label,value,false,value===province.dataset.default)));
    const container=province.closest('[data-province-container]');container.hidden=!options.length;province.disabled=!options.length;
  }
  function filterRecord(node,catalog){
    const k=catalog.dataset.filterCategory||'',q=(catalog.querySelector('[data-dog-catalog-search]')?.value||'').trim().toLocaleLowerCase();
    return (!k || (k==='batana'?node.dataset.productHandle.includes('batana'):node.dataset.productCategory===k))&&(!q||(node.dataset.productTitle+' '+node.dataset.productHandle).toLocaleLowerCase().includes(q));
  }
  function orderCatalog(catalog) {
    const grid=$('.dog-catalog-grid',catalog); if(!grid)return;
    const records=$$('[data-product-handle]',grid).map(node=>({node,handle:node.dataset.productHandle,available:node.dataset.productAvailable==='true',created:Number(node.dataset.productCreated)||0,price:Number(node.dataset.productPrice)||0}));
    const active=$('[data-filter-kind].active',catalog);
    Core.orderCatalog(records,catalog.dataset.catalogSort,cfg.heroHandle,catalog.dataset.catalogPackages==='true').forEach(record=>{record.node.hidden=Boolean(active&&record.node.dataset.kind!==active.dataset.filterKind)||!filterRecord(record.node,catalog);grid.append(record.node);});
    const empty=$('[data-catalog-empty]',grid);if(empty&&records.length)empty.remove();
    const filteredEmpty=$('[data-filter-empty]',catalog);if(filteredEmpty)filteredEmpty.hidden=!records.length||records.some(r=>!r.node.hidden);
  }
  doc.addEventListener('click',e=>{const b=e.target.closest('[data-dog-category]');if(!b)return;
    const cat=b.closest('[data-catalog]'),val=b.dataset.dogCategory;
    cat.dataset.filterCategory=cat.dataset.filterCategory===val?'':val;
    $$('[data-dog-category]',cat).forEach(el=>{const on=el.dataset.dogCategory===cat.dataset.filterCategory;el.classList.toggle('active',on);el.setAttribute('aria-pressed',String(on));});
    $('[data-dog-all]',cat)?.classList.toggle('active',!cat.dataset.filterCategory);orderCatalog(cat);});
  doc.addEventListener('input',e=>{if(e.target.matches('[data-dog-catalog-search]'))orderCatalog(e.target.closest('[data-catalog]'));});
  doc.addEventListener('submit',e=>{if(e.target.querySelector('[data-dog-catalog-search]')){e.preventDefault();orderCatalog(e.target.closest('[data-catalog]'));}});
  const loadedCatalogs=new WeakSet();
  async function initCatalog(catalog) {
    if(loadedCatalogs.has(catalog))return;loadedCatalogs.add(catalog);orderCatalog(catalog);
    const grid=$('.dog-catalog-grid',catalog);if(!grid)return;
    const pages=Number(grid.dataset.totalPages)||1,current=Number(grid.dataset.currentPage)||1;
    const seen=new Set($$('[data-product-handle]',grid).map(n=>n.dataset.productHandle));
    try {
      for(let page=1;page<=pages;page++){
        if(page===current)continue;
        const url=new URL(location.href);url.searchParams.set('page',page);url.searchParams.set('section_id',catalog.dataset.sectionId);
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('Catalogue unavailable');
        const template=doc.createElement('template');template.innerHTML=await response.text();
        const next=$('.dog-catalog-grid',template.content);if(!next)throw new Error('Catalogue unavailable');
        $$('[data-product-handle]',next).forEach(card=>{if(!seen.has(card.dataset.productHandle)){seen.add(card.dataset.productHandle);grid.append(card);}});
        orderCatalog(catalog);
      }
      const pagination=$('[data-catalog-pagination]',catalog);if(pagination)pagination.hidden=true;
    } catch (_) { /* Keep native page links available if another catalogue page cannot load. */ }
  }
  $$('[data-country-select]').forEach(select=>{if(select.dataset.default)select.value=select.dataset.default;populateProvince(select);});
  doc.addEventListener('keydown',event=>{
    if(!dialog)return;
    if(event.key==='Escape'){event.preventDefault();closeDialog();}
    if(event.key==='Tab'){
      const items=focusable(dialog),first=items[0],last=items.at(-1);
      if(!items.length){event.preventDefault();dialog.focus();}
      else if(event.shiftKey && (doc.activeElement===first || doc.activeElement===dialog)){event.preventDefault();last.focus();}
      else if(!event.shiftKey && doc.activeElement===last){event.preventDefault();first.focus();}
    }
  });
  initOffers();
  $$('[data-catalog]').forEach(initCatalog);
  doc.addEventListener('shopify:section:load',()=>{initOffers();$$('[data-catalog]').forEach(initCatalog);});
})(typeof window !== 'undefined' ? window : globalThis);
